import { useCallback, useEffect, useState } from "react";
import { host } from "../../utils/constants";
import checkIfLoggedInOrNot from "../common/helper/login";
import { User } from "../common/types/user";
import myaxios from "../myAxios";

function useGetMe() {
  const [data, setData] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refetch = useCallback(() => {
    myaxios
      .get(host + "/auth/user_profile")
      .then((data) => setData(data.data.data as User))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, []);
  const fetchUser = useCallback(async () => {
    return myaxios
      .get(host + "/auth/user_profile")
      .then((data) => data.data.data as User)
      .catch((err) => setError(err));
  }, []);

  useEffect(() => {
    let isActive = true;

    const load = async () => {
      setLoading(true);
      const loggedIn = await checkIfLoggedInOrNot();

      if (!isActive) return;

      if (loggedIn) {
        refetch();
      } else {
        setLoading(false);
      }
    };

    void load();

    return () => {
      isActive = false;
    };
  }, [refetch]);
  return { data, loading, error, fetchUser, refetch };
}

export default useGetMe;
